import { GlModal, GlFormTextarea, GlFormGroup } from '@gitlab/ui';
import { translate } from '../../../../../utils/i18n';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  TITLE: translate('AgenticToolRejectionModal.title', 'Provide Rejection Reason'),
  DESCRIPTION: translate('AgenticToolRejectionModal.description', 'You are about to reject the tool execution. Would you like to provide a reason?'),
  LABEL: translate('AgenticToolRejectionModal.label', 'Rejection reason'),
  PLACEHOLDER: translate('AgenticToolRejectionModal.placeholder', "Explain why you're rejecting this tool execution..."),
  SUBMIT_TEXT: translate('AgenticToolRejectionModal.submitText', 'Submit Rejection'),
  BACK_TEXT: translate('AgenticToolRejectionModal.backText', 'Back')
};
var script = {
  name: 'AgenticToolRejectionModal',
  components: {
    GlModal,
    GlFormTextarea,
    GlFormGroup
  },
  props: {
    /**
     * Controls the visibility of the modal
     */
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      rejectionMessage: ''
    };
  },
  computed: {
    submitAction() {
      return {
        text: this.$options.i18n.SUBMIT_TEXT,
        attributes: {
          variant: 'danger',
          icon: 'cancel',
          size: 'small',
          'data-testid': 'submit-rejection'
        }
      };
    },
    backAction() {
      return {
        text: this.$options.i18n.BACK_TEXT,
        attributes: {
          variant: 'default',
          icon: 'chevron-left',
          size: 'small',
          'data-testid': 'back-button'
        }
      };
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.rejectionMessage = '';
      }
    }
  },
  methods: {
    handleSubmit() {
      /**
       * Emitted when the user submits the rejection reason
       * @param {string|null} reason - The rejection reason provided by the user, or null if empty
       */
      this.$emit('submit', this.rejectionMessage || null);
      this.rejectionMessage = '';
    },
    handleBack() {
      /**
       * Emitted when the user clicks the back button to return to the approval modal
       */
      this.$emit('back');
    },
    handleModalHide(event) {
      // If the modal is being hidden by the X button or ESC key,
      // treat it as a deny-force action
      if (event.trigger !== 'ok' && event.trigger !== 'cancel') {
        this.handleBack();
      }
    }
  },
  i18n
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-modal',{attrs:{"visible":_vm.visible,"modal-id":"agentic-tool-rejection-modal","title":_vm.$options.i18n.TITLE,"action-primary":_vm.submitAction,"action-secondary":_vm.backAction,"no-close-on-backdrop":true,"no-close-on-esc":true,"data-testid":"agentic-tool-rejection-modal"},on:{"primary":_vm.handleSubmit,"secondary":_vm.handleBack,"hide":_vm.handleModalHide}},[_c('p',{staticClass:"gl-mb-3",attrs:{"data-testid":"rejection-description"}},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.DESCRIPTION)+"\n  ")]),_vm._v(" "),_c('gl-form-group',{staticClass:"gl-mb-0",attrs:{"label":_vm.$options.i18n.LABEL,"label-for":"rejection-message","optional":true}},[_c('gl-form-textarea',{attrs:{"id":"rejection-message","placeholder":_vm.$options.i18n.PLACEHOLDER,"rows":3,"max-rows":6,"resize":false,"data-testid":"rejection-message-input","autofocus":""},model:{value:(_vm.rejectionMessage),callback:function ($$v) {_vm.rejectionMessage=$$v;},expression:"rejectionMessage"}})],1)],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
export { i18n };
